import styles from './Header.module.css';

export default function Header() {
  return (
    <header className={styles.header}>
      <img
        src="/briandawson-logo.png"
        alt="Brian Dawson"
        className={styles.logo}
      />
    </header>
  );
}
